module.exports = __webpack_public_path__ + "img/10.fcb3f3fa.jpg";